import { Instance, types } from 'mobx-state-tree';

const ClientProgramGroupProgram = types.model('ClientProgramGroupProgram', {
	id: types.identifierNumber,
	name: types.optional(types.string, ''),
	official_name: types.optional(types.string, ''),
	isTis: types.optional(types.number, 0),
});

export default ClientProgramGroupProgram;

export interface ClientProgramGroupProgramModel
	extends Instance<typeof ClientProgramGroupProgram> {}
